/**
 * Os 11 alertas operacionais, do lado da tela.
 *
 * Aqui só ficam rótulo, cor e ordem. A regra e o limiar são do backend, com hora do servidor — antes
 * a conta era feita no navegador do operador, com o limite escrito no código e valores diferentes em
 * dois arquivos.
 */

export const ROTULOS_DO_ALERTA = {
  GPS_SEM_ATUALIZACAO: "GPS parado",
  SEM_CAPTURA: "Sem captura",
  MOTORISTA_OFFLINE: "Motorista offline",
  PRECISAO_BAIXA: "GPS impreciso",
  FALHA_DE_SINCRONIZACAO: "Falha de sincronização",
  ESPERA_CARGA: "Espera de carga",
  ESPERA_DOCUMENTACAO: "Espera de documentação",
  ESPERA_DESCARGA: "Espera de descarga",
  STATUS_SEM_ATUALIZACAO: "Status parado",
  FORA_DO_RAIO_DA_PARADA: "Fora do ponto",
  CANHOTO_FORA_DO_LOCAL: "Canhoto fora do local",
};

/**
 * Vermelho para o que interrompe o rastreio, laranja para o que atrasa a operação. A distinção é a
 * mesma da legenda por cores da tela: etapa operacional numa cor, percurso noutra.
 */
export const CORES_DO_ALERTA = {
  GPS_SEM_ATUALIZACAO: "red",
  SEM_CAPTURA: "red",
  MOTORISTA_OFFLINE: "red",
  FALHA_DE_SINCRONIZACAO: "red",
  PRECISAO_BAIXA: "gold",
  ESPERA_CARGA: "orange",
  ESPERA_DOCUMENTACAO: "orange",
  ESPERA_DESCARGA: "orange",
  STATUS_SEM_ATUALIZACAO: "orange",
  FORA_DO_RAIO_DA_PARADA: "volcano",
  CANHOTO_FORA_DO_LOCAL: "volcano",
};

/** Quem interrompe o rastreio aparece primeiro: é o que o operador precisa resolver hoje. */
const ORDEM = [
  "SEM_CAPTURA",
  "GPS_SEM_ATUALIZACAO",
  "MOTORISTA_OFFLINE",
  "FALHA_DE_SINCRONIZACAO",
  "FORA_DO_RAIO_DA_PARADA",
  "ESPERA_DESCARGA",
  "ESPERA_CARGA",
  "ESPERA_DOCUMENTACAO",
  "STATUS_SEM_ATUALIZACAO",
  "CANHOTO_FORA_DO_LOCAL",
  "PRECISAO_BAIXA",
];

export function ordenarAlertas(alertas) {
  if (!Array.isArray(alertas)) return [];
  return [...alertas].sort(
    (a, b) => ORDEM.indexOf(a.chave) - ORDEM.indexOf(b.chave),
  );
}

export function rotuloDoAlerta(alerta) {
  return ROTULOS_DO_ALERTA[alerta?.chave] || alerta?.chave || "";
}

/** "há 3h20 sem posição, o limite é 45 min" — o número medido e o limite que o servidor usou. */
export function detalheDoAlerta(alerta) {
  if (!alerta) return "";
  if (alerta.unidade === "m") {
    return `${alerta.valor} m, acima do limite de ${alerta.limite} m`;
  }
  if (alerta.unidade === "itens") {
    return `${alerta.valor} ${alerta.valor === 1 ? "posição recusada" : "posições recusadas"} no último envio`;
  }
  return `${formatarMinutos(alerta.valor)}, acima do limite de ${formatarMinutos(alerta.limite)}`;
}

function formatarMinutos(minutos) {
  if (!Number.isFinite(minutos)) return "—";
  if (minutos < 60) return `${minutos} min`;
  const horas = Math.floor(minutos / 60);
  const resto = minutos % 60;
  if (horas < 24) return resto ? `${horas}h${String(resto).padStart(2, "0")}` : `${horas}h`;
  const dias = Math.floor(horas / 24);
  return `${dias} ${dias === 1 ? "dia" : "dias"}`;
}
